import React from 'react';
import { PageContent } from 'shared/components/PageContent';
import { AppBar } from '@ihsm/ui-shared';
import { GridAndChartWrapper } from '../components/GridAndChartWrapper/GridAndChartWrapper';
import { ViewControlsContainer } from '../components/ViewControlsContainer/ViewControlsContainer';
import { useMarketDataPage } from '../hooks/useMarketDataPage';
import { MarketDataSearchTree } from '../components/MarketDataSearchTree/MarketDataSearchTree';
import './MarketDataPage.scss';

export const MarketDataPage: React.FC = (): JSX.Element => {
  const {
    forceLoadingScreen,
    forceNoDataScreen,
    selectedAssetClassesFactor,
    chartData,
    isSearchTreeCollapsed,
    isSideBarCollapsed,
    isTableVisible,
    isTimeseriesVisible,
    assetClassType,
    onChartChange,
    selectedViewOptions,
    setSelectedViewOptions,
    appBarMenuItems,
  } = useMarketDataPage();

  return (
    <div className="market-data-page">
      <PageContent
        forceLoadingScreen={forceLoadingScreen}
        forceNoDataScreen={forceNoDataScreen}
        headerControls={
          <AppBar menuItems={appBarMenuItems}>
            {selectedAssetClassesFactor}
          </AppBar>
        }
        searchTree={<MarketDataSearchTree />}
        viewControls={
          <ViewControlsContainer
            assetClassType={assetClassType}
            onChartChange={onChartChange}
            selectedViewOptions={selectedViewOptions}
            setSelectedViewOptions={setSelectedViewOptions}
          />
        }
      >
        <GridAndChartWrapper
          chartData={chartData}
          isSearchTreeCollapsed={isSearchTreeCollapsed}
          isSideBarCollapsed={isSideBarCollapsed}
          isTableVisible={isTableVisible}
          isTimeseriesVisible={isTimeseriesVisible}
        />
      </PageContent>
    </div>
  );
};
